import { render, staticRenderFns } from "./MakeInactiveModal.vue?vue&type=template&id=555dbc0a&"
import script from "./MakeInactiveModal.vue?vue&type=script&lang=js&"
export * from "./MakeInactiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports